/**
 * Active Rectangle + Casual Games (from production config DB)
 * Last refreshed: 2026-04-10
 *
 * Only games in this list will appear on the showcase.
 * Update this list when new games are added to production.
 */
const ACTIVE_RECTANGLE_GAMES = new Set([
  // ── Casual Games ──
  'balonismo',
  'flying-caramelo',
  'blackjack',
  'coin-flip',
  'coin-race',
  'craps',
  'crash',
  'diamonds',
  'dice',
  'hilo',
  'keno',
  'limbo',
  'mines',
  'one-wrong-step',
  'plinko',
  'plinko-x',
  'roulette',
  'train',
  'wheel',
  // ── Rectangle Slots ──
  'aries-reactor-of-fortune',
  'aquarius-fortune-wheel',
  'aztecs-mystery',
  'battleship',
  'black-assassin',
  'capricorns-orb-of-fortune',
  'chicken-uncrossable',
  'disco-fever',
  'dragon-crash',
  'eggy-pop',
  'farmageddon',
  'fiesta-blue',
  'fiesta-green',
  'fiesta-magenta',
  'fiesta-red',
  'firecrackers-fortune',
  'firecrackers-fortune-100',
  'fortune-pig',
  'gold-diggers',
  'golden-koi-trail',
  'inmate-outcuss',
  'iron-valor',
  'lucky-caramelo-1000',
  'lucky-caramelo-2',
  'lucky-duck',
  'lucky-fox',
  'lucky-panda',
  'lucky-snake',
  'lucky-turtle',
  'magic-circus',
  'money-mania',
  'pig-mines',
  'pirates-treasure-reel',
  'pisces-realm-of-fortune',
  'prosperity-clash',
  'prosperity-dragon',
  'prosperity-dragon-golden-reel',
  'prosperity-horse',
  'prosperity-mouse',
  'prosperity-ox',
  'prosperity-rabbit',
  'prosperity-tiger',
  'realm-of-thunder',
  'rudolphs-gift',
  'shapes-of-fortune',
  'shapes-of-fortune-xmas',
  'smash-fury',
  'solar-pong',
  'swaggy-caramelo',
  'swaggy-caramelo-super',
  'the-lone-fireball',
  'the-lucky-year',
  'tinkering-box',
  'treasures-of-hades',
  'wheel-of-wealth',
  'year-of-the-golden-horse',
]);

export default ACTIVE_RECTANGLE_GAMES;
